import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Önce i18n yapılandırmasını import et (App'den önce olmalı)
import './i18n/i18n';
import './index.css';
import App from './App';  
import reportWebVitals from './reportWebVitals';

// Global ENV değişkenini tanımla (Push notification için kullanılacak)
declare global {
  interface Window {
    ENV?: {
      API_URL: string;
      APP_VERSION: string;
    };
    pushNotificationManager: any;
  }
}

// API URL'yi global olarak ayarla
window.ENV = {
  API_URL: process.env.REACT_APP_API_URL || window.location.origin,
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0'
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000 // 10 minutes
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
